<template>
  <ul>
    <li v-for="i in 10" :key="i" class="entrance-card">
      <div
        v-if="notificationList[i-1]"
        class="entrance-item"
        :class="[{
          active: enterItem && enterItem.idx === notificationList[i-1].idx,
          noPhone: !notificationList[i-1].guest.phone
        }]"
      >
        <span v-if="isWaitingNumber" class="entrance-num">
          {{ notificationList[i-1].waitSequenceStatic }}
        </span>
        <span v-if="notificationList[i-1].guest.phone" class="entrance-phone">
          {{ notificationList[i-1].guest.phone.slice(-4) }}
        </span>
      </div>
      <div v-else>-</div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['notification-list', 'enter-item', 'list', 'is-waiting-number'],
  name: 'entranceList'
}
</script>

<style lang="scss" scoped>
@import "@/css/style.scss";

.entrance-card {
  height: calc(50% - 5px);
  flex-basis: calc(20% - 6px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11px;
  font-size: 48px;
  font-weight: $regular;
  color: $gray_700;
  background-color: $gray_900;
  overflow: hidden;

  @include fhd_combo {
    height: calc(50% - 8px);
    flex-basis: calc(20% - 9px);
    border-radius: 16px;
    font-size: 72px;
  }

  @include qhd_combo {
    height: calc(50% - 11px);
    flex-basis: calc(20% - 13px);
    border-radius: 21px;
    font-size: 96px;
  }

  .entrance-item {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: $white;
    padding: 20px 21px 16px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;

    @include fhd_combo {
      padding: 31px 30px 25px;
    }
    @include qhd_combo {
      padding: 41px 42px 33px;
    }

    &.noPhone {
      padding: 18px 21px;
      @include fhd_combo {
        padding: 28px 31px;
      }
      @include qhd_combo {
        padding: 36px 40px;
      }
    }

    &.active {
      .entrance-num {
        color: $orange;
        font-weight: $bold;
      }

      .entrance-phone {
        font-weight: $bold;
      }
    }

    .entrance-num {
      font-size: 48px;
      font-weight: $regular;
      color: $gray_900;

      @include fhd_combo {
        font-size: 72px;
      }

      @include qhd_combo {
        font-size: 96px;
      }
    }

    .entrance-phone {
      font-size: 24px;
      font-weight: $regular;
      color: $gray_700;
      background-color: $gray_200;
      border: 1px solid $gray_300;
      border-radius: 8px;
      padding: 2px 7px;
      margin: 3px 0 0 0;

      @include fhd_combo {
        font-size: 36px;
        border: 2px solid $gray_300;
        border-radius: 16px;
        padding: 2px 10px;
        margin: 4px 0 0 0;
      }

      @include qhd_combo {
        font-size: 48px;
        border: 3px solid $gray_300;
        padding: 2px 13px;
        margin: 5px 0 0 0;
      }
    }
  }
}
</style>
